import { getProductTitle } from '@/src/app/(base)/products/[slug]/utils/getProductTitle';
import { useProductCardContext } from '../ProductCardContext';
import { Box } from '@/src/packages/components/ui/Box';

export const ProductCardTitle = () => {
  const { productVariant } = useProductCardContext();

  return (
    <Box as="h3" fontWeight="medium" className='truncate'>
      {getProductTitle(
        productVariant.product.title,
        productVariant.productOptionValue.name
      )}
    </Box>
  );
};
